import React, { useEffect, useState } from "react";

// Smoothly counts up to `value`. Supports number or numeric string.
export default function AnimatedNumber({ value, duration = 1100, format }) {
  const target = typeof value === "string" ? parseFloat(value.replace(/[^0-9.-]/g, "")) || 0 : value;
  const [n, setN] = useState(0);

  useEffect(() => {
    let raf;
    const start = performance.now();
    const from = 0;
    const step = (t) => {
      const p = Math.min(1, (t - start) / duration);
      // easeOutCubic
      const eased = 1 - Math.pow(1 - p, 3);
      setN(from + (target - from) * eased);
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);

  const display = format ? format(n) : Math.round(n).toLocaleString();
  return <span>{display}</span>;
}
